import { twJoin } from 'tailwind-merge';
import { Sidebar } from '../Sidebar/Sidebar';
import { Navbar } from '../Navbar/Navbar';
import { FCC } from '@dynamika-shared/types/general';
import React from 'react';
import { twMerge } from '@dynamika-shared/utils/twMerge';

export const LayoutView: FCC<{
  sidebarCollapsed: boolean | undefined;
  className?: string;
  MenuComponent?: React.FunctionComponent<{
    sidebarCollapsed: boolean | undefined;
  }>;
}> = ({ children, sidebarCollapsed, MenuComponent, className }) => {
  return (
    <div
      data-testid='LayoutView'
      className='flex h-full justify-between transition-all'
    >
      <div data-testid='LayoutSidebarOutlet' className='h-full'>
        <Sidebar MenuComponent={MenuComponent} />
      </div>
      <div
        data-testid='LayoutContentOutlet'
        className={twJoin(
          'h-full overflow-y-auto',
          sidebarCollapsed
            ? 'w-[calc(100vw-88px)]'
            : 'w-[calc(100vw-240px)] xl:w-[calc(100vw-224px)]'
        )}
      >
        <Navbar />
        <div
          className={twMerge(
            'flex h-[calc(100vh-76px)] flex-col px-4 pb-1.5 mini:px-2 mini:pb:1',
            className
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
